import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CandidateService } from '@app/services/candidate.service';
import { commonComponents } from '@app/shared/common components/common components';
import { of } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import * as feather from 'feather-icons';



@Component({
  standalone: false,
  selector: 'app-candidate-dropdown',
  templateUrl: './candidate-dropdown.component.html',
  styleUrls: ['./candidate-dropdown.component.css'],
})
export class CandidateDropdownComponent implements OnInit {
  bgPlanData = 23;
  candidates: any[] = [];
  filteredCandidates: any[] = [];
  loading = false;
  isLoading = false;
  vid: any;
  searchTerm = '';
  confirmDeleteId: number | null = null;
  showDeleteModal = false;
  candidateToDelete: any = null;
  deleteType: 'hard' | 'soft' = 'soft';
  errorMS: string
  currentPage = 1;
  itemsPerPage = 25;
  sortField = '';
  sortDirection = 1;
  sortIcon: Record<string, string> = {
    id: '',
    candidate_id: '',
    name: '',
    email: '',
    job_ref_id: '',
    created_by: '',
    created_on: '',
  };
  errorMessage: string | null = null;
  error: any;
  showFormModal = false;
  formFields = commonComponents.CandidateList.ManualScreeing;
  formData: any
  showIdvOnlyModal = false;
  idvOnlyFormFields = commonComponents.CandidateList.IdvOnlyFields;
  idvOnlyFormData: any = {};
  idvOnlyBgPlanData = 23;
  idvOnlyErrorMS: string;
  idvOnlyBtnDisable = false;
  decisionOptions = commonComponents.CandidateList.Droupdown;
  assessmentOptions = commonComponents.CandidateList.assessment;
  modifyDate: string;
  placeholderImage = '../../assets/img/placeholder-selfie.jpg';
  errorDisplay: string;
  isChecked = false;
  enable = false;
  resubmit = false
  headers = commonComponents.CandidateList.headers
  tableBodyData: any
  btnDissble = false
  tosterMessage = {
    message: '',
    type: ''
  }
  noDataFound = false;
  isValid: any[]

  constructor(private candidateService: CandidateService,
    private router: Router,
    private route: ActivatedRoute,
    private manualScreeningService: CandidateService) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.searchTerm = params['searchTerm'] || '';
      this.currentPage = +params['currentPage'] || 1;
      this.sortField = params['sortField'] || '';
      this.sortDirection = +params['sortDirection'] || 1;
      this.enable = params['enable'] === 'true';
      this.loadCandidates();
    });
    if (this.enable === true) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
  }

  ngAfterViewInit() {
    feather.replace();
  }

  loadCandidates(): void {
    this.isLoading = true;
    this.candidateService
      .loadCandidates(this.enable)
      .pipe(
        catchError(() => {
          this.setErrorMessage('Failed to load candidates');
          return of([]);
        }),
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe((res) => {
        const candidateslist = res
        const allCanidatslist = candidateslist.data
        this.candidates = allCanidatslist.sort((a, b) => a.id - b.id);
        this.filteredCandidates = this.candidates;
        this.filterCandidates();
        this.tableBody(this.candidates)
      });
  }

  tableBody(data: any) {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    const paginatedData = data.slice(startIndex, endIndex);
    this.tableBodyData = paginatedData.map((candidate) => ({
      id: candidate.id,
      candidateImage: this.img(candidate.selfie),
      name: candidate.name,
      email: candidate.email,
      idv_status: candidate.idv_status === "IDV Not Applicable" ? "Not Applicable" : candidate.idv_status,
      bg_status: candidate.bg_status,
      assessment_source: candidate.assessment_source,
      created_on: this.formatDate(candidate.created_on),
      modified_on: this.formatDate(candidate.modified_on),
      actions: '',
      is_deleted: candidate.is_archived,
      candidate_id: candidate.candidate_id
    }))
  }
  img(imgUrl: any): string {
    if (!imgUrl || imgUrl.indexOf('no-data') !== -1) {
      return this.placeholderImage;
    }
    const image = new Image();
    image.onload = () => {
    };
    image.onerror = () => {
      imgUrl = this.placeholderImage;;
    };
    image.src = imgUrl;
    return imgUrl;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}/${day}/${year}  ${hours}:${minutes}:${seconds}`;
  }

  filterCandidates(): void {
    this.searchTerm = this.searchTerm.trim().toLowerCase();
    if (this.searchTerm) {
      const filteredCandidates = this.candidates.filter(
        (candidate) => {
          const matchId = candidate.id.toString().toLowerCase().includes(this.searchTerm);
          const matchName = candidate.name.toLowerCase().includes(this.searchTerm);
          const matchEmail = candidate.email.toLowerCase().includes(this.searchTerm);
          return matchId || matchName || matchEmail;
        });
      if (filteredCandidates.length > 0) {
        this.currentPage = 1;
        this.tableBody(filteredCandidates);
        this.noDataFound = false;
      } else {
        this.clearTable();
        this.noDataFound = true;
      }
    } else {
      console.log('No search term, displaying all candidates.');
      this.tableBody(this.candidates);
      this.noDataFound = false;
    }

    this.sortCandidates();
  }
  clearTable() {
    this.tableBodyData = [];
    this.isLoading = false;
  }

  get totalPages(): number {
    return Math.ceil(this.filteredCandidates.length / this.itemsPerPage);
  }

  get paginatedCandidates() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const htmldata = this.filteredCandidates.map((i) => ({
      ...i,
      idv_status: i.idv_status ? i.idv_status.toUpperCase() : 'NO STATUS',
      bg_status: i.bg_status ? i.bg_status.toUpperCase() : 'NO STATUS',
    }));
    return htmldata.slice(startIndex, startIndex + this.itemsPerPage);
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateQueryParams();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateQueryParams();
    }
  }

  goToFirstPage(): void {
    this.currentPage = 1;
    this.updateQueryParams();
  }

  goToLastPage(): void {
    this.currentPage = this.totalPages;
    this.updateQueryParams();
  }

  changeSort(field: string): void {
    if (this.sortField === field) {
      this.sortDirection = -this.sortDirection;
    } else {
      this.sortField = field;
      this.sortDirection = 1;
    }
    this.sortCandidates();
    this.updateQueryParams();
  }

  sortCandidates(): void {
    this.filteredCandidates.sort((a, b) => {
      const aValue = this.sortField === 'name' ? a.name.toLowerCase() : a[this.sortField];
      const bValue = this.sortField === 'name' ? b.name.toLowerCase() : b[this.sortField];

      const isANullOrEmpty = aValue === null || aValue === '' || aValue === undefined;
      const isBNullOrEmpty = bValue === null || bValue === '' || bValue === undefined;

      if (isANullOrEmpty && !isBNullOrEmpty) {
        return 1;
      } else if (!isANullOrEmpty && isBNullOrEmpty) {
        return -1;
      }

      if (aValue < bValue) {
        return -1 * this.sortDirection;
      } else if (aValue > bValue) {
        return 1 * this.sortDirection;
      }
      return 0;
    });

    Object.keys(this.sortIcon).forEach((key) => (this.sortIcon[key] = ''));
    this.sortIcon[this.sortField] = this.sortDirection === 1 ? '↑' : '↓';
  }

  setErrorMessage(message: string) {
    this.tosterMessage = {
      message: message,
      type: 'error'
    };
  }

  onInvestigateAndCheck(candidate: any): void {
    console.log(candidate)
    const candidate_id = candidate.candidate_id;
    this.isLoading = true;

    if (candidate.idv_status === "Not Applicable") {
      this.candidateService.investigate(candidate_id, 'BackgroundCheck').pipe(
        catchError(() => {
          this.setErrorMessage('Failed to investigate with BackgroundCheck');
          return of(null);
        })
      ).subscribe((response) => {
        this.isLoading = false;
        if (response) {
          const res = response[0];
          const id = res.id;
          const fname = res.payload.first_name;
          const lname = res.payload.last_name;
          const matrixParams = {
            name: `${fname} ${lname}`,
            ID: 'BIO',
            recordId: id,
            candidate_id: candidate_id,
          };
          this.router.navigate(['/home/assessment-investigation', { ...matrixParams }]);
        } else {
          this.setErrorMessage('Failed to complete investigation');
        }
      });
    } else {
      this.candidateService
        .investigate(candidate_id, 'inline_assessment')
        .pipe(
          catchError(() => {
            this.isLoading = false;
            this.setErrorMessage('Failed to investigate with inline_assessment');
            return of(null);
          }),
          switchMap((response) => {
            if (response && (response[0].status === 'COMPLETED')) {
              this.vid = 'BIO';
              return this.candidateService.investigate(candidate_id, 'BackgroundCheck').pipe(
                catchError(() => {
                  return of(response);
                }),
              );
            }else {
              this.vid = 'ID_VY';
              return of(response);
            }
          }),
          finalize(() => {
            this.isLoading = false;
          }),
        )
        .subscribe((response) => {
          if (response) {
            const res = response[0];
            const id = res.id;
            const fname = res.payload.candidate.firstName;
            const lname = res.payload.candidate.lastName;
            const matrixParams = {
              name: `${fname} ${lname}`,
              recordId: id,
              candidate_id:  candidate_id
            };
            this.router.navigate(['/home/assessment-investigation', { ...matrixParams }]);
          } else {
            this.tosterMessage = {
              message: 'Failed To Complete Investigation',
              type: 'error'
            }
          }
        });
    }

  }

  confirmDelete(candidate: any): void {
    this.candidateToDelete = candidate;
    this.showDeleteModal = true;
    this.deleteType = 'soft';
  }

  cancelDelete(): void {
    this.showDeleteModal = false;
    this.candidateToDelete = null;
    this.deleteType = 'soft';
  }

  performDelete(): void {
    if (!this.candidateToDelete) return;
    const candidateId = this.candidateToDelete.candidate_id;
    this.showDeleteModal = false;
    this.candidateService.softDeleteCandidate(candidateId).subscribe(
      () => {
        this.loadCandidates();
      },
      () => {
        this.setErrorMessage('Failed to delete candidate');
      },
    );
    this.candidateToDelete = null;
  }

  updateQueryParams(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        currentPage: this.currentPage !== 1 ? this.currentPage : null,
        sortField: this.sortField || null,
        sortDirection: this.sortDirection !== 1 ? this.sortDirection : null,
        enable: this.enable ? 'true' : 'false',
      },
      queryParamsHandling: 'merge',
    });
  }

  openFormModal() {
    this.showFormModal = true;
    this.bgPlan('')
  }

  cancelForm() {
    this.showFormModal = false;
    this.errorMS = ""
    this.formData = {}
  }


  onDateChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

    if (dateRegex.test(value)) {
      const selectedDate = new Date(value);
      const today = new Date();
      if (selectedDate > today) {
        this.errorMS = ('Date of Birth cannot be in the future.');
        input.value = '';
        this.formData['date_of_birth'] = '';
      } else {
        this.formData['date_of_birth'] = value;
      }
    } else {
      this.errorMS = ('Invalid date format.');
      input.value = '';
      this.formData['date_of_birth'] = '';
    }
  }

  validateNumberField(event: any, fieldName: string) {
    let input = event.target.value;
    this.errorMS = ""
    if (fieldName === 'phoneNumber') {
      input = input.replace(/[^0-9+]/g, '');
      if (input.length > 12) {
        input = input.slice(0, 12);
      }
      event.target.value = input;
      this.formData[fieldName] = input;
    } else if (fieldName === 'ssn') {
      input = input.replace(/[^0-9+]/g, '');
      if (input.length > 9) {
        input = input.slice(0, 9);
      }
      event.target.value = input;
      this.formData[fieldName] = input;
    } else if (fieldName === 'driver_license_number') {
      input = input.toUpperCase()
      event.target.value = input.toUpperCase();
      this.formData[fieldName] = input.toUpperCase();
    }
  }
  private validateFormData(): boolean {
    this.btnDissble = false
    this.isLoading = false
    const fieldMappings: Record<number, string[]> = commonComponents.CandidateList.fieldChecking
    const requiredFields = fieldMappings[this.bgPlanData] || [];
    return this.validateRequiredFields(requiredFields);
  }

  private validateRequiredFields(requiredFields: string[]): boolean {
    for (const field of requiredFields) {
      if (!this.formData[field] || this.formData[field].trim() === '') {
        console.error(`Validation Error: ${field} is missing or empty.`);
        this.errorMS = 'Please fill out all required fields.';
        return false;
      }
    }
    return true;
  }

  submitForm() {
    this.isLoading = true
    this.btnDissble = true
    if (!this.validateFormData()) {
      return;
    }
    const fieldMappings = commonComponents.CandidateList.fieldChecking[this.bgPlanData]
    if (fieldMappings.includes("ssn") && this.formData.ssn.length === 9) {
      this.createManualScreening()
    } else {
      console.log('object')
      if (!fieldMappings.includes("ssn")) {
        this.createManualScreening()
      } else {
        this.errorMS = "Please confirm the length 9 of the SSN number."
      }
    }
  }
  trimSpaces(fieldName: string): void {
    if (this.formData[fieldName]) {
      this.formData[fieldName] = this.formData[fieldName].trim();
    }
  }

  createManualScreening() {
    this.manualScreeningService.manualScreening(this.formData).subscribe({
      next: (response) => {
        this.loadCandidates();
        this.cancelForm();
        this.btnDissble = false
        this.tosterMessage = {
          message: 'Manual screening added Successfully',
          type: 'success'
        }
        if (this.resubmit) {
          setTimeout(() => {
            this.openFormModal()
            this.resubmit = true
          }, 100);
        }
        console.log('Manual screening succeeded', response);
      },
      error: (err) => {
        console.error('Error occurred during manual screening:', err);
        this.isLoading = false
        this.btnDissble = false
        this.tosterMessage = {
          message: 'Select any 1 Assessment Package Name',
          type: 'failed'
        }

      },
      complete: () => {
        console.log('Manual screening request completed.');
      },
    });
  }

  toggleIncludeDelete(): void {
    this.enable = !this.enable;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        searchTerm: this.searchTerm || null,
        currentPage: null,
        sortField: this.sortField || null,
        sortDirection: this.sortDirection !== 1 ? this.sortDirection : null,
        enable: this.enable ? 'true' : 'false',
      },
      queryParamsHandling: 'merge',
    });
    //this.loadCandidates();  
  }
  trackByFn(index: number, candidate: any): number {
    return candidate.id;
  }

  bgPlan(value: any) {
    this.bgPlanData = +value
    this.isValid = commonComponents.CandidateList.fieldChecking[this.bgPlanData]
    this.formData = {
      ...this.formData,
      assessmentPackageId: value,
    };
  }

  assessmentOption(value: any) {
    this.formData = {
      ...this.formData,
      assessment_source: value,
    };
  }

  reupdate() {
    this.resubmit = (!this.resubmit)
  }

  openIdvOnlyModal() {
    this.showIdvOnlyModal = true;
    this.idvOnlyFormData = {};
    this.idvOnlyBgPlanData = 23;
    this.idvOnlyErrorMS = '';
  }

  cancelIdvOnly() {
    this.showIdvOnlyModal = false;
    this.idvOnlyErrorMS = '';
    this.idvOnlyFormData = {};
  }

  bgPlanIdvOnly(value: any) {
    this.idvOnlyBgPlanData = +value;
    this.idvOnlyFormData = { ...this.idvOnlyFormData, assessmentPackageId: value };
  }

  validateIdvOnlyNumberField(event: any, fieldName: string) {
    let input = event.target.value;
    this.idvOnlyErrorMS = '';
    if (fieldName === 'ssn') {
      input = input.replace(/[^0-9]/g, '');
      if (input.length > 9) input = input.slice(0, 9);
      event.target.value = input;
      this.idvOnlyFormData[fieldName] = input;
    }
  }

  submitIdvOnly() {
    this.idvOnlyBtnDisable = true;
    const requiredFields = ['assessmentPackageId', 'first_name', 'last_name', 'email', 'ssn'];
    for (const f of requiredFields) {
      if (!this.idvOnlyFormData[f] || this.idvOnlyFormData[f].toString().trim() === '') {
        this.idvOnlyErrorMS = 'Please fill out all required fields.';
        this.idvOnlyBtnDisable = false;
        return;
      }
    }
    if (this.idvOnlyFormData.ssn.length !== 9) {
      this.idvOnlyErrorMS = 'Please confirm the SSN is 9 digits.';
      this.idvOnlyBtnDisable = false;
      return;
    }
    this.candidateService.triggerIdvOnly(this.idvOnlyFormData).subscribe({
      next: () => {
        this.loadCandidates();
        this.cancelIdvOnly();
        this.idvOnlyBtnDisable = false;
        this.tosterMessage = { message: 'IDV email sent successfully', type: 'success' };
      },
      error: () => {
        this.idvOnlyBtnDisable = false;
        this.tosterMessage = { message: 'Failed to send IDV email', type: 'failed' };
      },
    });
  }

}


